import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';

/** Same copy as the Efficiency Breakdown chart info icon. */
export const EFFICIENCY_BREAKDOWN_TOOLTIP = 'Shop-side flags are counted first, including when other flags are also present: a submitted match to a line or vendor that was not on the original Nexsyis response, a match to an original line that was AP Entered or had zero quantity, a reprocess that adds or removes at least one page, or a reprocess that changes the invoice type.\n\nNeeded flags are what remains with an amount, discount, special vendor, quantity, or price flag.\n\nYaxle-side flags are the match flag and any other upload flag still left.';

const FLAG_TOOLTIP_TITLES = ['Shop-side flags', 'Needed flags', 'Yaxle-side flags'];

function boldFlagTitles(text: string, keyPrefix: string): ReactNode[] {
    const pattern = new RegExp(`(${FLAG_TOOLTIP_TITLES.join('|')})`, 'g');
    return text.split(pattern).map((part, index) => (
        FLAG_TOOLTIP_TITLES.includes(part)
            ? <b key={`${keyPrefix}-${index}`}>{part}</b>
            : part
    ));
}

/** Paragraphs and bold slice names, matching the reporting chart info tooltip. */
export function efficiencyBreakdownTooltipLabel(): ReactNode {
    const paragraphs = EFFICIENCY_BREAKDOWN_TOOLTIP.split(/\n\n+/);
    return (
        <>
            {paragraphs.map((paragraph, index) => (
                <Box as="p" key={index} mt={index === 0 ? 0 : 2} mb={0}>
                    {boldFlagTitles(paragraph, String(index))}
                </Box>
            ))}
        </>
    );
}
